
import { Component, Prop, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { WPXFormValue } from '@/components/templates/WPXForm';
import AddTeamAgentsForm from '@/services/Dossier/team/forms/AddTeamAgentsForm';
import { UserBaseInfoInterface } from '@/services/Users/Interfaces';
import { AgentInterface } from '@/services/Dossier/user/interfaces';

@Component({
  mixins: [
    Themeable,
  ],
})
export default class AddAgentsDialog extends Vue {
  @Prop() private users!: AgentInterface[];
  @Prop() private teamId!: number;
  @Prop() private managerName!: string;
  @Prop() private usersMap!: { [key: string]: UserBaseInfoInterface };

  private loading: boolean = true;
  private visible: boolean = true;

  private form: WPXFormValue<AddTeamAgentsForm> = new WPXFormValue(AddTeamAgentsForm);

  get message(): string {
    return `Add agents to ${this.managerName}'s team`;
  }

  private async addAgents(): Promise<void> {
    this.$emit('add-agents', { users: this.form.data.users, teamId: this.teamId });
    this.visible = false;
    this.loading = false;
    this.destroyComponent();
  }

  private getItemText(user: AgentInterface): string {
    if (!user.id) {
      return '';
    }

    return this.usersMap[user.id].email;
  }

  private created(): void {
    this.loading = false;
  }

  private destroyComponent(): void {
    this.$emit('close');
  }
}
